/**
 * Aspect — Portal client router (hash-based)
 */

const routes = new Map();

export function route(path, handler) {
  routes.set(path, handler);
}

export function navigate(path, replace = false) {
  const hash = path.startsWith("#") ? path : `#${path}`;
  if (replace) window.location.replace(hash);
  else window.location.hash = hash.slice(1);
}

export function currentPath() {
  const raw = window.location.hash.replace(/^#/, "") || "/";
  const path = raw.split("?")[0];
  return path.startsWith("/") ? path : `/${path}`;
}

export function startRouter(fallback) {
  const run = () => {
    const path = currentPath();
    const handler = routes.get(path) ?? fallback;
    if (handler) handler({ path, navigate });
  };
  window.addEventListener("hashchange", run);
  run();
}

export function editorUrl(aptId) {
  const base = new URL("./index.html", window.location.href);
  if (aptId) base.searchParams.set("apt", aptId);
  return base.href;
}

export function tourUrl(tourId) {
  const base = new URL("./index.html", window.location.href);
  base.searchParams.set("tour", tourId);
  return base.href;
}
